import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Skeleton } from "@/components/ui/skeleton";
import type { ReactElement } from "react";

export function GroupDetailSkeleton(): ReactElement {
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Wide}>
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex min-w-0 items-center gap-4">
          <Skeleton className="size-12 shrink-0 rounded-lg" />
          <div className="flex flex-col gap-2">
            <Skeleton className="h-7 w-48" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-20" />
        </div>
      </header>

      <div className="mt-2 flex flex-col gap-6">
        <div className="flex gap-2">
          <Skeleton className="h-9 w-28" />
          <Skeleton className="h-9 w-28" />
          <Skeleton className="h-9 w-28" />
        </div>
        <Skeleton className="h-96 w-full rounded-lg" />
      </div>
    </CenteredLayout>
  );
}
